import { Link } from 'react-router-dom';
import InlineCTA from './InlineCTA';

export default function SportsSafetyHub() {
  return (
    <article
      style={{
        fontFamily: 'sans-serif',
        lineHeight: 1.8,
        color: '#d1d5db',
        padding: '40px 20px',
        maxWidth: 800,
        margin: '0 auto',
      }}
    >
      <h1 style={{ color: '#d4af37', fontSize: 28, marginBottom: 8 }}>
        運彩防詐指南 2026｜假老師、假群組、假平台一次破解
      </h1>
      <p style={{ color: '#9ca3af', fontSize: 14, marginBottom: 32 }}>
        最後更新：2026-03-22 ｜ 閱讀時間：約 10 分鐘
      </p>

      <p>
        台灣運彩市場每年投注額突破千億，龐大的資金流量也吸引了大量詐騙集團。根據刑事局統計，2025 年博弈詐騙案件中，
        <strong style={{ color: '#fff' }}>運彩相關詐騙占比超過 35%</strong>，其中「假老師帶牌」和「假投注群組」是最常見的手法。
        這篇跨叢集指南將結合運彩知識與防詐安全策略，幫助你在享受運彩樂趣的同時，有效避開各種陷阱。
      </p>
      <p>
        無論你是剛開始接觸運動投注的新手，還是已經有一定經驗但想確認自己使用的管道是否安全，
        這篇文章都能提供實用的檢查清單和行動方案。
      </p>

      <nav
        className="my-8 p-4 bg-[#111] rounded-lg border border-yellow-500/10"
        aria-label="文章目錄"
      >
        <p style={{ color: '#d4af37', fontWeight: 'bold', marginBottom: 8, marginTop: 0 }}>
          目錄
        </p>
        <ul style={{ paddingLeft: 20, margin: 0, fontSize: 14 }}>
          <li><a href="#fake-teacher" style={{ color: '#93c5fd' }}>運彩老師詐騙手法大拆解</a></li>
          <li><a href="#fake-group" style={{ color: '#93c5fd' }}>假投注群組辨識技巧</a></li>
          <li><a href="#platform-check" style={{ color: '#93c5fd' }}>運彩平台安全檢查清單</a></li>
          <li><a href="#legit-vs-underground" style={{ color: '#93c5fd' }}>正規管道 vs 地下盤口</a></li>
          <li><a href="#scam-types" style={{ color: '#93c5fd' }}>運彩詐騙類型一覽表</a></li>
          <li><a href="#self-rescue" style={{ color: '#93c5fd' }}>被騙後自救 SOP</a></li>
          <li><a href="#responsible" style={{ color: '#93c5fd' }}>負責任博弈聲明</a></li>
        </ul>
      </nav>

      {/* Section 1 */}
      <h2 id="fake-teacher" style={{ color: '#d4af37', marginTop: 48 }}>
        運彩老師詐騙手法大拆解
      </h2>
      <p>
        「跟著老師買，穩賺不賠！」——這句話幾乎是所有運彩詐騙的開場白。這些自稱「運彩分析師」或「體育數據專家」的人，
        通常會透過 LINE 群組、Facebook 社團或 YouTube 頻道招攬「學員」。他們的核心手法包括：
      </p>

      <h3 style={{ color: '#e5e7eb', marginTop: 32 }}>兩面下注法（對沖詐騙）</h3>
      <p>
        詐騙集團會同時建立兩個群組：A 群推薦「主隊贏」，B 群推薦「客隊贏」。比賽結束後，
        猜對的那一群成為「成功案例」，猜錯的群組則悄悄解散。這樣無論結果如何，總有一半的人相信老師「真的很準」。
        經過三到四輪篩選，剩下的人會深信不疑，然後被引導到詐騙平台進行大額投注。
      </p>
      <p>
        更多運彩詐騙手法的深入分析，可以參考我們的{' '}
        <Link to="/blog/sports-betting-scam-prevention" style={{ color: '#93c5fd' }}>
          運彩詐騙預防完整指南
        </Link>。
      </p>

      <h3 style={{ color: '#e5e7eb', marginTop: 32 }}>假戰績截圖</h3>
      <p>
        透過 PS 修圖或使用模擬投注網站產生看似驚人的勝率截圖。常見的造假特徵包括：
        戰績時間區間可疑（只顯示連勝區間）、截圖畫質異常一致（批次生產）、
        以及投注金額與生活照炫富不成比例。看到這類截圖，一律先當成行銷素材，不要當成實力證明。
      </p>

      <InlineCTA />

      {/* Section 2 */}
      <h2 id="fake-group" style={{ color: '#d4af37', marginTop: 48 }}>
        假投注群組辨識技巧
      </h2>
      <p>
        假投注群組已經從過去的 LINE 社群擴展到 Telegram、Discord 甚至 Instagram。
        以下是幾個快速辨識假群組的關鍵指標：
      </p>
      <ul>
        <li>
          <strong style={{ color: '#fff' }}>入群要求先儲值</strong>——任何要求你「先入金才能看分析」的群組都有高度詐騙嫌疑。
          正規分析社群不會要求你到特定網站開戶作為入群條件。
        </li>
        <li>
          <strong style={{ color: '#fff' }}>群內「暱稱」高度一致</strong>——詐騙群組通常有大量機器人帳號充場面，
          暱稱格式類似（如「小明_贏了」「阿偉_跟單中」），發言時間也過於規律。
        </li>
        <li>
          <strong style={{ color: '#fff' }}>禁止質疑</strong>——正常的討論社群歡迎不同意見，
          但詐騙群組會迅速踢除提出質疑的成員，或用「你不信就退群」來壓制。
        </li>
        <li>
          <strong style={{ color: '#fff' }}>強調「保證獲利」</strong>——根據{' '}
          <a href="https://www.fsc.gov.tw" target="_blank" rel="noopener noreferrer" style={{ color: '#93c5fd' }}>
            金融監督管理委員會
          </a>
          的警示，任何宣稱「保證獲利」的投資或博弈行為都涉嫌違法。
        </li>
      </ul>

      {/* Section 3 */}
      <h2 id="platform-check" style={{ color: '#d4af37', marginTop: 48 }}>
        運彩平台安全檢查清單
      </h2>
      <p>
        在台灣，合法的運彩管道只有台灣運彩官方投注站與官方 APP。以下這份檢查清單，
        可以幫你辨識自稱「運彩」的仿冒網站：
      </p>

      <div style={{ overflowX: 'auto', marginTop: 16, marginBottom: 16 }}>
        <table className="w-full text-sm border-collapse" style={{ minWidth: 600 }}>
          <thead>
            <tr style={{ backgroundColor: '#111' }}>
              <th className="border border-yellow-500/10" style={{ padding: '10px 12px', color: '#d4af37', textAlign: 'left' }}>檢查項目</th>
              <th className="border border-yellow-500/10" style={{ padding: '10px 12px', color: '#d4af37', textAlign: 'left' }}>台灣運彩官方</th>
              <th className="border border-yellow-500/10" style={{ padding: '10px 12px', color: '#d4af37', textAlign: 'left' }}>危險信號</th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-[#111]">
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>牌照/執照</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>依《運動彩券發行條例》發行，政府特許</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>自稱持有國外牌照，但在台經營本身就違法</td>
            </tr>
            <tr>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>出金速度</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>投注站兌領或撥入本人帳戶</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>反覆要求加碼才能出金</td>
            </tr>
            <tr className="bg-[#111]">
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>客服品質</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>官方客服電話、官網與實體投注站</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>只有 LINE 聯繫、回覆制式化</td>
            </tr>
            <tr>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>網站歷史</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>官方網址，可從官方 APP 商店下載</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>網域註冊不到 6 個月</td>
            </tr>
            <tr className="bg-[#111]">
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>賠率水準</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>與國際盤口差異在合理範圍</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>賠率異常偏高（吸引入金後再黑吃）</td>
            </tr>
            <tr>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>儲值贈金</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>不做儲值贈金</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>首存 200% 但流水 50 倍以上</td>
            </tr>
          </tbody>
        </table>
      </div>


      {/* Section 4 */}
      <h2 id="legit-vs-underground" style={{ color: '#d4af37', marginTop: 48 }}>
        正規管道 vs 地下盤口
      </h2>
      <p>
        台灣目前唯一合法的運動投注管道是{' '}
        <a href="https://www.sportslottery.com.tw" target="_blank" rel="noopener noreferrer" style={{ color: '#93c5fd' }}>
          台灣運動彩券官網
        </a>
        （由威剛科技經營）。除此之外的所有運彩平台在台灣法律框架下都不具備合法投注資格。
      </p>

      <div style={{ overflowX: 'auto', marginTop: 16, marginBottom: 16 }}>
        <table className="w-full text-sm border-collapse" style={{ minWidth: 600 }}>
          <thead>
            <tr style={{ backgroundColor: '#111' }}>
              <th className="border border-yellow-500/10" style={{ padding: '10px 12px', color: '#d4af37', textAlign: 'left' }}>比較項目</th>
              <th className="border border-yellow-500/10" style={{ padding: '10px 12px', color: '#d4af37', textAlign: 'left' }}>台灣運彩（正規）</th>
              <th className="border border-yellow-500/10" style={{ padding: '10px 12px', color: '#d4af37', textAlign: 'left' }}>地下盤口（非法）</th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-[#111]">
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>法律保障</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>受政府監管，糾紛有法律途徑</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>無法律保障，報警反而可能自曝違法</td>
            </tr>
            <tr>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>賠率水準</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>略低（含稅和管理成本）</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>通常較高（用高賠率吸引玩家）</td>
            </tr>
            <tr className="bg-[#111]">
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>出金保證</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>100% 保證出金</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>可能拒絕出金或直接跑路</td>
            </tr>
            <tr>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>投注品項</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>主流賽事為主</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>品項豐富但可能操控結果</td>
            </tr>
            <tr className="bg-[#111]">
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>個資安全</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>個資保護法規範</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>個資可能被轉賣或用於詐騙</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p>
        雖然地下盤口的賠率看起來更吸引人，但風險完全由玩家自行承擔。
        關於運彩投注的基本策略和正確觀念，可以參考{' '}
        <Link to="/blog/sports-betting-guide" style={{ color: '#93c5fd' }}>
          運動彩券完整攻略
        </Link>。
      </p>

      {/* Section 5 */}
      <h2 id="scam-types" style={{ color: '#d4af37', marginTop: 48 }}>
        運彩詐騙類型一覽表
      </h2>

      <div style={{ overflowX: 'auto', marginTop: 16, marginBottom: 16 }}>
        <table className="w-full text-sm border-collapse" style={{ minWidth: 600 }}>
          <thead>
            <tr style={{ backgroundColor: '#111' }}>
              <th className="border border-yellow-500/10" style={{ padding: '10px 12px', color: '#d4af37', textAlign: 'left' }}>詐騙類型</th>
              <th className="border border-yellow-500/10" style={{ padding: '10px 12px', color: '#d4af37', textAlign: 'left' }}>典型話術</th>
              <th className="border border-yellow-500/10" style={{ padding: '10px 12px', color: '#d4af37', textAlign: 'left' }}>辨識方法</th>
              <th className="border border-yellow-500/10" style={{ padding: '10px 12px', color: '#d4af37', textAlign: 'left' }}>危險等級</th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-[#111]">
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>假老師帶牌</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>「勝率 90%，跟著買就對了」</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>查驗歷史戰績、要求即時直播分析</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', color: '#ef4444' }}>★★★★★</td>
            </tr>
            <tr>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>假投注群組</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>「加入 VIP 群，每月穩賺 10 萬」</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>觀察群組成員互動是否自然</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', color: '#ef4444' }}>★★★★★</td>
            </tr>
            <tr className="bg-[#111]">
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>假平台詐騙</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>「儲值送 300%」</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>查詢網域年齡、搜尋負面評價</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', color: '#f97316' }}>★★★★</td>
            </tr>
            <tr>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>內線消息詐騙</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>「我有球員私下消息」</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>職業運動資訊高度透明，無「內線」</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', color: '#f97316' }}>★★★★</td>
            </tr>
            <tr className="bg-[#111]">
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', fontWeight: 'bold', color: '#fff' }}>AI 預測軟體詐騙</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>「AI 演算法準確率 95%」</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px' }}>要求提供第三方驗證的歷史績效</td>
              <td className="border border-yellow-500/10" style={{ padding: '10px 12px', color: '#eab308' }}>★★★</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Section 6 */}
      <h2 id="self-rescue" style={{ color: '#d4af37', marginTop: 48 }}>
        被騙後自救 SOP
      </h2>
      <p>
        如果你已經不幸落入運彩詐騙，以下是一份按照時間順序整理的自救行動清單：
      </p>
      <ol>
        <li>
          <strong style={{ color: '#fff' }}>立即停止所有轉帳行為</strong>——無論對方以什麼理由（稅金、手續費、加碼解鎖）要求你繼續匯款，
          都不要再轉入任何一毛錢。
        </li>
        <li>
          <strong style={{ color: '#fff' }}>截圖保存所有證據</strong>——包括對話紀錄、轉帳明細、平台網址、
          群組名稱、對方帳號資訊等。這些都是後續報案的重要證據。
        </li>
        <li>
          <strong style={{ color: '#fff' }}>撥打 165 反詐騙專線</strong>——這是內政部警政署的官方反詐騙諮詢專線，
          24 小時運作，可以協助你進行帳號凍結和案件立案。
        </li>
        <li>
          <strong style={{ color: '#fff' }}>向銀行申請帳戶暫時凍結</strong>——如果你有向詐騙帳號轉帳，
          立即聯繫你的銀行，嘗試攔截款項。
        </li>
        <li>
          <strong style={{ color: '#fff' }}>前往派出所報案</strong>——取得報案三聯單，這是後續法律程序的基礎文件。
        </li>
      </ol>

      <InlineCTA />

      <div className="my-8 p-4 bg-[#111] rounded-lg border border-yellow-500/10">
        <p style={{ margin: 0, fontSize: 14, color: '#fbbf24' }}>
          <strong>延伸閱讀：</strong>想了解更多運彩詐騙手法，請看{' '}
          <Link to="/blog/sports-betting-scam-prevention" style={{ color: '#93c5fd' }}>
            運彩詐騙防範指南
          </Link>。
          想學習正確的運彩投注觀念，請參考{' '}
          <Link to="/blog/sports-betting-guide" style={{ color: '#93c5fd' }}>
            運動彩券完整攻略
          </Link>。
        </p>
      </div>

      {/* Responsible Gambling */}
      <h2 id="responsible" style={{ color: '#d4af37', marginTop: 48 }}>
        負責任博弈聲明
      </h2>
      <div className="my-8 p-4 bg-[#111] rounded-lg border border-yellow-500/10">
        <p style={{ margin: 0, fontSize: 14, color: '#9ca3af' }}>
          本文僅供教育與資訊參考用途，不鼓勵任何形式的賭博行為。博弈具有高度風險，可能導致嚴重的財務損失。
          請務必在合法範圍內參與博弈活動，並設定嚴格的預算上限。如果你或身邊的人出現疑似賭博成癮的症狀，
          請立即撥打衛福部安心專線 1925 或戒賭專線 (02)2346-0199 尋求專業協助。
          未滿 18 歲者禁止參與任何形式的博弈活動。
        </p>
      </div>
    </article>
  );
}
